'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var win = window;
var doc = win.document;
var docEl = doc.documentElement;

/**
 * 判断元素相对Y轴的位置;
 * @param {Element} el 元素对象
 * @return {Number} [-1, 1]; 相对页面的位置; 从最上不可见到最下不可见;
 */

exports.default = function (el) {
  var elRect = el.getBoundingClientRect();

  return (0, _base2.default)(elRect.left, elRect.width, docEl.clientWidth);
};

module.exports = exports['default'];